import './App.css';
import Choose from './components/choose/choose';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import Main from './components/main/main';
import Service from './components/service/service';

function App() {
  return (
    <div>
      <Header></Header>
      <Main></Main>
      <Service></Service>
      <Choose></Choose>
      <Footer></Footer>
    </div>
  );
}

export default App;
